// Path: src\Components\HtmlFreeGames\HtmlFreeGameByID.jsx
import React, { useEffect, useState } from "react";
import BaseHome from "../Home/BaseHome";
import Games from "../../assets/images/games.svg";
import Game from "../../images/box.png";
import { useTranslation } from "react-i18next";
import { getHTMLCategoryList, getHTMLGame, updateView } from "../../api/htmlFreeGames";
import { useNavigate } from "react-router";
import { kFormatter } from "../../Utilities/kFormatter";

const HtmlFreeGameByID = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [HTMLGame, setHTMLGame] = useState(null);
    const [updateViewId, setUpdateViewId] = useState("");
    const [activeFreeGame, setactiveFreeGame] = useState(null);
    const [directLink, setdirectLink] = useState(null);

    useEffect(() => {
        if(localStorage?.getItem("activeFreeGameById")) {
            fetchData();
        }
    }, []); // Empty dependency array ensures this effect only runs on mount and unmount

    const fetchData = async () => {
        try {
          const res = await updateView({
              "html5Category": localStorage?.getItem("activeFreeGameId"),
              "htmlGame": localStorage?.getItem("activeFreeGameById"),
              "status": "start",
              "isActive": true
          });
          if(res?.success && res?.item) {
              setUpdateViewId(res?.item?._id);
          }
        } catch (error) {
        }
    };

    const handleOnBackPress = async () => {
        if(localStorage?.getItem("activeFreeGameById")) {
            const res = await updateView({
                "html5Category": localStorage?.getItem("activeFreeGameId"),
                "htmlGame": localStorage?.getItem("activeFreeGameById"),
                "status": "end",
                "isActive": true,
                "logId": updateViewId
            });
        }

        localStorage?.removeItem("DirectLink")
        localStorage?.removeItem("activeFreeGame")
        localStorage?.removeItem("activeFreeGameId")
        localStorage?.removeItem("activeFreeGameById")
        navigate(-1);
    }

    return (
        <>
            <BaseHome title={localStorage?.getItem("activeFreeGame")} isFreeGameIframe={true} onBackClick={() => handleOnBackPress()} >
                <div style={{ height: '100vh', width: '100%', overflow: 'hidden' }}>
                    <iframe
                        src={localStorage?.getItem("DirectLink")}
                        title={localStorage?.getItem("activeFreeGame")}
                        style={{ width: '100%', height: '100%', border: 'none' }}
                    />
                </div>
            </BaseHome>
        </>
    );
};

export default HtmlFreeGameByID;
